import React from 'react'

import { Nav, Main, Footer, Providers } from '../components/layout'
import {
  HeroSection,
  DemoSection,
  HowItWorksSection,
  ProcessSection,
  LearnMoreSection,
} from '../components/views/index/'
import CMS from '@talus-analytics/library.airtable-cms'

const IndexPage = (): JSX.Element => {
  return (
    <Providers>
      <CMS.SEO />
      <Nav />
      <Main>
        <HeroSection />
        <DemoSection />
        <ProcessSection />
        <HowItWorksSection />
        <LearnMoreSection />
      </Main>
      <Footer />
    </Providers>
  )
}

export default IndexPage
